import { useEffect } from 'react';

export const KEYS = {
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    ESCAPE: 27,
    SPACE: 32,
};

/**
 * `KeyboardEvent.keyCode` est déprécié et n'est plus renseigné par certains
 * environnements (navigation vocale, claviers virtuels, outils d'assistance).
 * On accepte donc aussi `KeyboardEvent.key`, qui est la propriété standard.
 */
const KEY_NAMES = {
    [KEYS.ARROW_LEFT]: 'ArrowLeft',
    [KEYS.ARROW_UP]: 'ArrowUp',
    [KEYS.ARROW_RIGHT]: 'ArrowRight',
    [KEYS.ARROW_DOWN]: 'ArrowDown',
    [KEYS.ESCAPE]: 'Escape',
    [KEYS.SPACE]: ' ',
};

const useKeyboardKeys = (keys = {}, { eventName = 'keydown' } = {}) => {
    const keysNames = Object.keys(keys);
    const keysListeners = keysNames.map((key) => keys[key]);
    useEffect(() => {
        const onKeyDown = (e) => {
            const { keyCode = null, key = null } = e;
            const matchedKey =
                keysNames.find(
                    (name) =>
                        (keyCode !== null && `${keyCode}` === name) ||
                        (key !== null && KEY_NAMES[name] === key),
                ) || null;
            if (matchedKey !== null) {
                keys[matchedKey](e);
            }
        };
        document.addEventListener(eventName, onKeyDown);
        return () => {
            document.removeEventListener(eventName, onKeyDown);
        };
    }, [...keysNames, ...keysListeners, eventName]);
};

export default useKeyboardKeys;
